import React from "react";
import PropTypes from "prop-types";

import { ArrowSpanStyled, ArrowWrapper } from "./ArrowWrapper";

const Arrow = props => {
  const { direction, color } = props;

  return (
    <ArrowWrapper>
      <ArrowSpanStyled color={color} direction={direction} />
    </ArrowWrapper>
  );
};

Arrow.propTypes = {
  direction: PropTypes.string.isRequired,
  color: PropTypes.string
};

export default React.memo(Arrow);
